import { classNames } from '@dimjs/utils';
import { CommonPropsWithChildren } from '../utils';
import './styles/passcode.less';

export type PasscodeProps = CommonPropsWithChildren & {
  gridsCount?: number;
  value: string;
  isPlain?: boolean;
  isError?: boolean;
  isFocused?: boolean;
  onFocus?: (e: React.FocusEvent<HTMLDivElement>) => void;
  onBlur?: () => void;
};
export const Passcode = (props: PasscodeProps) => {
  const columns = props.gridsCount || 6;
  const value = props.value;

  const passcodeContent = () => {
    const valueList = value.substring(0, columns).split('');
    const passcodeRenderList = [] as JSX.Element[];
    for (let index = 0; index < columns; index++) {
      const className = classNames({
        caret: index === valueList.length,
        dot: index < valueList.length && !props.isPlain,
      });
      passcodeRenderList.push(
        <div className={classNames('v-passcode-item', className)} key={index}>
          {props.isPlain ? valueList[index] : ''}
        </div>,
      );
    }
    return passcodeRenderList;
  };

  const className = classNames(
    'v-passcode',
    {
      'v-passcode-plain': props.isPlain,
      'v-passcode-error': props.isError,
      'v-passcode-focused': props.isFocused,
    },
    props.className,
  );

  return (
    <div className={className} style={props.style}>
      <div
        className="v-passcode-container"
        tabIndex={0}
        onFocus={props.onFocus}
        onBlur={() => {
          props.onBlur?.();
        }}
      >
        {passcodeContent()}
      </div>
      {props.children}
    </div>
  );
};
